import { Outlet } from 'react-router-dom';

export function StreamlitRoot() {
  return <Outlet />;
}
